import { Dispatch } from 'redux';
import { ApplicationProfileService } from '../../../services/applicationProfile.service';

export const getApplicationProfiles: any = (force: boolean = false) => async (dispatch: Dispatch, getState: any) => {
  try {
    const state = getState()?.applicationProfile;
    const isLoading = state?.loading;
    const existing = (state?.data?.data ?? state?.data ?? []) as any[];
    const currentTenantId = (() => { try { return JSON.parse(sessionStorage.getItem('tenant') || '{}')?.TenantId || null; } catch { return null; } })();
    const lastTenantId = state?.lastTenantId ?? null;
    const sameTenant = currentTenantId && lastTenantId && currentTenantId === lastTenantId;
    if ((isLoading && !force) || (!force && sameTenant && Array.isArray(existing) && existing.length > 0)) {
      return existing;
    }
    dispatch({ type: 'GET_APPLICATION_PROFILES_LOADING' });
    const res = await ApplicationProfileService.getApplicationProfiles();
    dispatch({ type: 'GET_APPLICATION_PROFILES_SUCCESS', payload: res.value, meta: { tenantId: currentTenantId } });
  } catch (error) {
    dispatch({ type: 'GET_APPLICATION_PROFILES_ERROR' });
  }
};

export const deleteApplicationProfile: any = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'DELETE_APPLICATION_PROFILES_LOADING' });
    const res = await ApplicationProfileService.deleteApplicationProfile(id);
    dispatch({ type: 'DELETE_APPLICATION_PROFILES_SUCCESS', payload: id });
    // Return the response value to be used in the promise chain
    return res?.value || res;
  } catch (error: any) {
    dispatch({ type: 'DELETE_APPLICATION_PROFILES_ERROR' });
    throw error.response || error;
  }
};

export const getTestTypes: any = () => async (dispatch: Dispatch, getState: any) => {
  try {
    const state = getState()?.applicationProfile;
    const existing = (state?.testTypes?.data ?? state?.testTypes ?? []) as any[];
    if (Array.isArray(existing) && existing.length > 0) {
      return existing;
    }
    dispatch({ type: 'GET_TEST_TYPES_LOADING' });
    const res = await ApplicationProfileService.getTestType();
    dispatch({ type: 'GET_TEST_TYPES_SUCCESS', payload: res.value });
  } catch (error) {
    dispatch({ type: 'GET_TEST_TYPES_ERROR' });
  }
};

export const getBusinessUnits: any = () => async (dispatch: Dispatch, getState: any) => {
  try {
    const state = getState()?.applicationProfile;
    const existing = (state?.businessUnits?.data ?? state?.businessUnits ?? []) as any[];
    if (Array.isArray(existing) && existing.length > 0) {
      return existing;
    }
    dispatch({ type: 'GET_BUSINESS_UNITS_LOADING' });
    const res = await ApplicationProfileService.getBusinessUnits();
    dispatch({ type: 'GET_BUSINESS_UNITS_SUCCESS', payload: res.value });
  } catch (error) {
    dispatch({ type: 'GET_BUSINESS_UNITS_ERROR' });
  }
};

export const createApplicationProfile: any = (payload: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'CREATE_APPLICATION_PROFILE_LOADING' });
    const res = await ApplicationProfileService.createApplicationProfile(payload);
    dispatch({ type: 'CREATE_APPLICATION_PROFILE_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'CREATE_APPLICATION_PROFILE_ERROR' });
    throw error;
  }
};

export const updateApplicationProfile: any = (id: string, payload: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'UPDATE_APPLICATION_PROFILE_LOADING' });
    const res = await ApplicationProfileService.updateApplicationProfile(id, payload);
    dispatch({ type: 'UPDATE_APPLICATION_PROFILE_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'UPDATE_APPLICATION_PROFILE_ERROR' });
    throw error;
  }
};

export const getCompositeApplicationProfile: any = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'GET_COMPOSITE_APPLICATION_PROFILE_LOADING' });
    const res = await ApplicationProfileService.getCompositeApplicationProfile(id);
    dispatch({ type: 'GET_COMPOSITE_APPLICATION_PROFILE_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'GET_COMPOSITE_APPLICATION_PROFILE_ERROR' });
    throw error;
  }
};
